// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectExternalLinkMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_EXTERNAL_LINK_MESSAGE);
        this.Id = null;
        this.Name = null;
        this.Url = null;
        this.UseInternalBrowser = null;
        this.ExternalResource = null;
        this.ExternalLinkParameters = null;
        this.ExternalLinkWebContentDark = null;
        this.ExternalLinkWebContentLight = null;
    }
}
